export const EMPATHIZE_ACTIONS_KEYS = {
  clearSelectedIndex: 'clearSelectedIndex',
  getIdentifierSuggestions: 'getIdentifierSuggestions',
  getPopularSearches: 'getPopularSearches',
  getResultsSuggestions: 'getResultsSuggestions',
  getTermSuggestions: 'getTermSuggestions',
  increaseSelectedIndexX: 'increaseSelectedIndexX',
  decreaseSelectedIndexX: 'decreaseSelectedIndexX',
  increaseSelectedIndexY: 'increaseSelectedIndexY',
  decreaseSelectedIndexY: 'decreaseSelectedIndexY'
} as const;

export const EMPATHIZE_GETTERS_KEYS = {
  empathizeDetectedState: 'empathizeDetectedState',
  highlightedEmpathizeItem: 'highlightedEmpathizeItem',
  highlightedEmpathizeLayoutItem: 'highlightedEmpathizeLayoutItem',
  identifierSuggestions: 'identifierSuggestions',
  isLoading: 'isLoading',
  layout: 'layout',
  nextQueriesSuggestions: 'nextQueriesSuggestions',
  popularSearches: 'popularSearches',
  rawPopularSearches: 'rawPopularSearches',
  rawTermSuggestions: 'rawTermSuggestions',
  redirectionsSuggestions: 'redirectionsSuggestions',
  resultsSuggestions: 'resultsSuggestions',
  selectedIndexX: 'selectedIndexX',
  selectedIndexY: 'selectedIndexY',
  showOpen: 'showOpen',
  termSuggestions: 'termSuggestions'
} as const;

export const EMPATHIZE_MUTATIONS_KEYS = {
  clearEmpathizeState: 'clearEmpathizeState',
  saveEmpathizeResponse: 'saveEmpathizeResponse',
  setLoading: 'setLoading',
  setSelectedIndex: 'setSelectedIndex',
  setSelectedEmpathizeBlock: 'setSelectedEmpathizeBlock'
} as const;
